import serviceProvider from "./service-provider";

export default {
  //apiURL: 'http://localhost:3000',
  // apiURL: 'http://www.enviosweb.dev:3000',
  apiURL: "https://app.sacktechlogistics.com",
  serviceProvider,
};



// WEBPACK FOOTER //
// ./src/commons/index.js